module.exports = __webpack_public_path__ + "static/pij_img_left-28aba464470a8e4584ceed8518be397d.jpg";